const AppConst = {
    API_URL: window.API_URL,
    APP_VERSION: window.APP_VERSION
};

export default AppConst;